module.exports = __webpack_public_path__ + "ao.no1.8892bc76.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/ao.no1.jpg
// module id = ErfN
// module chunks = 0